// removed by extract-text-webpack-plugin
module.exports = {"backButton":"src-components-BackButton-__backButton-module___backButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackButton/backButton.module.css
// module id = 791
// module chunks = 0